import React from "react";
import { Column } from "./Column";
import { Row } from "./Row";
export const Subtitle = (props) => {
    return props.className ? React.createElement(Row, null,
        React.createElement(Column, { lg: 12, md: 12, sm: 12 },
            React.createElement("div", { style: { marginTop: '20px' } },
                React.createElement("h2", { className: props.className }, props.text)))) : React.createElement(Row, null,
        React.createElement(Column, { lg: 12, md: 12, sm: 12 },
            React.createElement("div", { style: { marginTop: '20px' } },
                React.createElement("h2", { className: 'ms-fontSize-18 ms-fontColor-black', style: { fontWeight: 'normal' } }, props.text))));
};
